The identifier for the `ApplicationLibraryQuestionSuggestion`.
